module.exports = __webpack_public_path__ + "img/shiba-loading.f2bfb48c.gif";